import { render, staticRenderFns } from "./CardPromoCode.vue?vue&type=template&id=38f2eb42&scoped=true&"
import script from "./CardPromoCode.vue?vue&type=script&lang=js&"
export * from "./CardPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./CardPromoCode.vue?vue&type=style&index=0&id=38f2eb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2eb42",
  null
  
)

export default component.exports